import styled, { css } from 'styled-components';

export const Content = styled.div`
  /* width: 1300px; */
  min-height: 920px;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 0 0 1px rgba(85, 85, 85, 0.2);
  padding-bottom: 40px;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #393e44;
    `}
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background-color: var(--cp-surface);
      color: var(--cp-text);
      box-shadow: 0 0 0 1px var(--cp-border);
      border-radius: var(--cp-brd-radius);
    `}
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #9a9a9a;
  border-top: 1px solid #9a9a9a;
  padding-left: 20px;
  width: 100%;
  height: 40px;
  span {
    font-size: 13px;
    color: #9a9a9a;
  }
`;

export const ScrollWrapper = styled.div`
  overflow: visible;
`;

export const RulesContent = styled.div`
  /* width: 610px; */
  /* width: 920px; */
  max-width: 1024px;
  margin-top: 20px;
`;
